import { render } from "./AddContactDialog.vue?vue&type=template&id=52ac85ee"
import script from "./AddContactDialog.vue?vue&type=script&lang=js"
export * from "./AddContactDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__